export enum TABS {
  TASKS = "tasks",
  NOTES = "notes",
}

export enum TASKS_TAB_SUBTABS {
  DETAILS = "taskDetails",
  CHAT = "chat",
  ADD_TASK = "addTask",
}
